export default "__VITE_ASSET__CeVl6HHC__"